import React from 'react';
import { CheckIcon, ClockIcon, CreditCardIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
import { CtaButton } from './CtaButton';
const included = ['Los 12 Tomos Maestros', '5 Bonos exclusivos incluidos', 'Para todos los niveles', 'Acceso inmediato', 'Garantía de 7 días'];
const guarantees = [{
  icon: LockIcon,
  label: 'Pago 100% seguro'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: CreditCardIcon,
  label: 'Crédito / Débito'
}];
export function OfferSection() {
  return <section id="comprar" aria-labelledby="oferta" className="scroll-mt-8 border-y border-ink-600 bg-ink-800" data-id="element-139" data-mp="rf7t7iyno2wr">
      <div className="mx-auto max-w-4xl px-5 py-16 sm:py-20" style={{
      paddingTop: "14px",
      paddingBottom: "27px"
    }} data-id="element-140" data-mp="wan6a8ou9us4">
        <div className="text-center" data-id="element-141" data-mp="2y4clqpu8jar7">
          <p className="inline-flex items-center gap-2 rounded-full border border-court-400/40 bg-court-900/60 px-4 py-2 text-xs font-bold uppercase tracking-[0.2em] text-court-200" data-id="element-142" data-mp="2y5fhpc6f03dz">
            <ClockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-143" data-mp="xwjs88fkypjw" />
            Precio de lanzamiento — por tiempo limitado
          </p>
          <h2 id="oferta" className="mt-6 font-display text-3xl uppercase leading-tight text-white sm:text-5xl" data-id="element-144" data-mp="sxysea48q7vz">
            Elegí tu Pro-Pack hoy
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-slate-400" data-id="element-145" data-mp="1lmmkaojhvvii">
            Valor total del pack completo: <span className="text-slate-200 line-through" data-id="element-146" data-mp="1gokyvwyljk3v">$92 USD</span>.
            Tu inversión hoy: <span className="font-bold text-ball-400" data-id="element-147" data-mp="1ckn2vv4kipf1">$19 USD</span>.
          </p>
        </div>

        <div className="mx-auto mt-10 max-w-2xl rounded-3xl border border-ball-400/40 bg-ink-900 p-7 shadow-ball sm:p-10" data-id="element-148" data-mp="17ljv42x7e53d">
          <h3 className="font-display text-2xl uppercase leading-tight text-white sm:text-3xl" data-id="element-149" data-mp="183zy4l36233">
            Padel Pro-Pack Definitivo
          </h3>
          <p className="mt-3 text-sm text-slate-400" data-id="element-150" data-mp="3tu9apbgrbjjv">
            El sistema completo para ordenar tus clases.
          </p>

          <ul className="mt-7 space-y-3 border-y border-ink-600 py-7" data-id="element-151" data-mp="2mnaxtx5s18a">
            {included.map(item => <li key={item} className="flex items-center gap-3 text-[15px] text-slate-200" data-id="element-152" data-mp="3ks9pe6ypltb4">
                <CheckIcon className="h-5 w-5 shrink-0 text-ball-400" strokeWidth={3} aria-hidden="true" data-id="element-153" data-mp="3ou50g36fzl23" />
                {item}
              </li>)}
          </ul>

          <div className="mt-7 flex flex-wrap items-end gap-4" data-id="element-154" data-mp="3b1own05pvj04">
            <span className="text-xl font-semibold text-slate-500 line-through" data-id="element-155" data-mp="3fvt039frx8wg">$38 USD</span>
            <span className="font-display text-6xl leading-none text-ball-400" data-id="element-156" data-mp="316wwpponwk26">$19</span>
            <span className="pb-2 text-sm font-bold uppercase tracking-widest text-slate-400" data-id="element-157" data-mp="3656so2i7noou">usd</span>
          </div>

          <CtaButton size="lg" className="mt-7 w-full" href={CHECKOUT_URL} data-id="element-158" data-mp="2s5fjcf2n2wh6">
            👉 Quiero el pack definitivo
          </CtaButton>

          <ul className="mt-7 flex flex-wrap justify-center gap-x-5 gap-y-3" data-id="element-159" data-mp="2dhox3bi0e8d8">
            {guarantees.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex items-center gap-2 text-xs font-medium text-slate-400" data-id="element-160" data-mp="28k5i29dhlrk8">
                <Icon className="h-4 w-4 text-court-400" aria-hidden="true" data-id="element-161" data-mp="2mk6kvudbb92c" />
                {label}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}